export default {
  productShow: {
    showInfo: 'View Details'
  },

  router: {
    index: {
      title: "Shanghai Shanmai Electronic Technology | Intelligent Access Control System · Customized Intelligent Lockers/Display Cabinets · Electronic Security Solutions",
      keywords: "Shanmai, Shanghai Shanmai, Shanmai Technology, Shanghai Shanmai Technology Development Co., Ltd., Official Website of Shanghai Shanmai Technology Development Co., Ltd.",
      description: "We provide customers with product technical support, as well as integrated solution design for security system engineering, structured cabling, intelligent system integration engineering, system maintenance and other projects."
    },
    entranceGuard: {
      title: "Intelligent Access Control | Intelligent Access Control System | Shanghai Shanmai Technology",
      keywords: "Intelligent access control system, access control management system, wireless access control, intelligent door lock, access control one-card pass, Shanmai Technology access control",
      description: "Shanmai Technology's intelligent access control system offers diversified solutions including wireless access control, intelligent door locks and one-card pass systems. Supporting facial recognition, fingerprint recognition, IC card and other unlocking methods, it provides enterprises with a safe and reliable access control management system."
    },
    displayCase: {
      title: "Intelligent Display Cabinet System | Intelligent Lockers | Shanghai Shanmai Technology",
      keywords: "Intelligent display cabinet, intelligent locker, intelligent showcase, display cabinet management system, intelligent display system, Shanmai Technology display cabinet",
      description: "Shanmai Technology's intelligent display cabinet system adopts advanced intelligent locks and management software, providing safe and reliable display solutions for high-value goods such as jewelry and luxury items. It supports remote management, intelligent anti-theft, data statistics and other functions."
    },
    softwarePlatform: {
      title: "Intelligent Management Software Platform | Shanghai Shanmai Technology",
      keywords: "Intelligent management system, access control management software, display cabinet management platform, IoT management system, Shanmai Technology software",
      description: "Shanmai Technology's intelligent management platform provides a unified management interface for access control and display cabinet systems, supporting multi-device linkage, data analysis, remote control and other functions to help enterprises achieve intelligent transformation."
    },
    entranceGuardSoftware: {
      title: "Intelligent Access Control Management Software | Shanghai Shanmai Technology",
      keywords: "Access control management software, access control system, visitor management system, attendance management, access control data analysis",
      description: "Shanmai Technology's access control management software offers complete control functions including permission management, visitor management, attendance statistics and real-time monitoring. Supporting remote control via mobile APP, it makes access control management more intelligent and convenient."
    },
    exhibitionSoftware: {
      title: "Intelligent Display Cabinet Platform | Shanghai Shanmai Technology",
      keywords: "Intelligent display cabinet software, display cabinet management system, intelligent display platform, display cabinet monitoring software, Shanmai Technology display cabinet software",
      description: "Shanmai Technology's intelligent display cabinet platform adopts advanced IoT technology, providing safe and reliable display solutions for high-value goods such as jewelry and luxury items."
    },
    aftTheSoftware: {
      title: "Intelligent After-sales Platform | Shanghai Shanmai Technology",
      keywords: "Intelligent after-sales system, after-sales management software, equipment maintenance platform, remote service system, Shanmai Technology after-sales software",
      description: "Shanmai Technology's intelligent after-sales platform provides equipment maintenance, realizes intelligent management of after-sales services, and improves service efficiency and customer satisfaction."
    },
    contact: {
      title: "Contact Us | Shanghai Shanmai Technology",
      keywords: "Shanmai Technology contact information, Shanghai Shanmai address, Shanmai Technology phone number, Shanmai Technology email, intelligent access control system supplier",
      description: "Shanghai Shanmai Technology Development Co., Ltd. focuses on R&D and application of intelligent systems such as intelligent access control, intelligent display cabinets and lockers, providing complete intelligent solutions. Welcome to call for consultation."
    },
    productShow: {
      title: "Product Display | Shanghai Shanmai Technology",
      keywords: "Intelligent access control products, intelligent display cabinet products, intelligent locker products, Shanmai Technology product display, access control controller, electronic lock, facial recognition access control",
      description: "Product display page of Shanghai Shanmai Technology, showcasing intelligent access control systems, display cabinets, lockers and other products, covering access control controllers, electronic locks, facial recognition access control and various intelligent devices."
    },
    productInfoShow: {
      title: "Product Details | Shanghai Shanmai Technology",
      keywords: "Intelligent access control product details, intelligent display cabinet product details, intelligent locker product parameters, Shanmai Technology product specifications, access control equipment technical parameters",
      description: "Product details page of Shanghai Shanmai Technology, providing detailed technical parameters, functional features, application scenarios and other information of intelligent access control systems, display cabinets, lockers and other products."
    },
    accessControlIntelligentSystemServices: {
      title: "Intelligent Access Control Management System | Shanghai Shanmai Technology",
      keywords: "Intelligent access control management system, access control system, access control management software, facial recognition access control system, access control solution, Shanmai Technology access control service",
      description: "Shanmai Technology's intelligent access control management system includes standalone, cloud platform and mobile application versions. Supporting facial recognition, fingerprint recognition, IC card and other unlocking methods, it excels in security, manageability and flexibility, providing security assurance and management convenience for most application scenarios."
    },
    smartDisplayCaseService: {
      title: "Intelligent Display Cabinet | Shanghai Shanmai Technology",
      keywords: "Intelligent display cabinet, intelligent display cabinet system, display cabinet intelligent lock, jewelry display cabinet management, luxury display cabinet solution, Shanmai Technology display cabinet service",
      description: "Shanmai Technology's intelligent display cabinet aims to build a safer, more convenient and intelligent protection system, helping high-end retail businesses achieve digital transformation. Addressing the limitations of traditional mechanical cabinet locks and information silo management, it further standardizes business processes, simplifies operations, improves operational efficiency, facilitates store intelligent construction and empowers enterprise management."
    },
    smartLockersService: {
      title: "Intelligent Lockers | Shanghai Shanmai Technology",
      keywords: "Intelligent lockers, intelligent parcel lockers, shared lockers, locker management system, school locker solution, Shanmai Technology locker service",
      description: "Shanmai Technology's intelligent locker system supports multiple unlocking methods, enabling fast item storage and retrieval with high security and convenience. It effectively improves space utilization, facilitates easy allocation by administrators, offers excellent flexibility with configurable temporary or long-term access rights, bringing multiple benefits to enterprises and employees."
    },
    glassDoorHandleSmartLockService: {
      title: "Intelligent Handle Lock | Shanghai Shanmai Technology",
      keywords: "Intelligent handle lock, glass door intelligent lock, wireless intelligent lock, recessed intelligent lock, commercial intelligent lock, Shanmai Technology handle lock service",
      description: "Shanmai Technology's intelligent handle lock can be recessed inside glass door handles without additional lock installation. Featuring multiple recognition methods such as card reading and NFC, it connects to private secure gateways via Bluetooth wireless transmission, providing a safe and convenient intelligent lock solution for glass doors."
    },
    rfidTakeService: {
      title: "RFID Intelligent Inventory Counting | Shanghai Shanmai Technology",
      keywords: "RFID intelligent inventory counting, RFID asset management, intelligent inventory system, warehouse inventory solution, fixed asset inventory, Shanmai Technology RFID service",
      description: "Shanmai Technology's intelligent management and anti-loss solution based on RFID technology realizes fast inventory counting, real-time monitoring, anti-theft alarm, data management and other functions by deploying hardware devices such as RFID tags, readers, intelligent fences, electronic access control and background management systems."
    }
  },

  common: {
    home: 'Home',
    about: 'About',
    products: 'Products',
    cases: 'Cases',
    news: 'News',
    contact: 'Contact',
    support: 'Support',
    more: 'More',
    submit: 'Submit',
    cancel: 'Cancel',
    learnMore: "Learn more ->",
    language: 'language',
    slogan: 'Act Resolutely, Achieve Distantly'
  },
  nav: {
    about: 'About Us',
    productLibrary: 'Products',
    accessControl: 'Access Control',
    smartCabinet: 'Smart Display | Smart Locker',
    softwarePlatform: 'Software Platform',
    accessControlPlatform: 'Access Control Platform',
    displayPlatform: 'Smart Display Platform',
    afterSalesPlatform: 'After-sales Service Platform',
    services: 'Services',
    accessControlSolution: 'Access Control System Solutions',
    smartDisplaySolution: 'Smart Display Cabinet Solutions',
    smartLockerSolution: 'Smart Locker Solutions',
    glassDoorSolution: 'Glass Door Smart Lock',
    smartBuildingSolution: 'Smart Building Solutions'
  },
  home: {
    banner: {
      title: 'Shanmai Technology',
      subtitle: 'UI Excellence',
      description: 'Shanghai Shanmai Technology (est. 2013) specializes in smart device design and development with multiple patents. Our core products include RFID management systems for jewelry stores, schools and hospitals, access control systems, smart cabinets and lockers, plus custom development. With security and electronics qualifications, we provide system integration and smart building solutions.',
      description_new: 'Specializing in the Design, Development and Manufacturing of Intelligent Devices'
    },
    about: {
      title: 'About Us',
      content: 'We focus on technical services, development and consulting. Our solutions include software development and system integration.'
    },
    service: {
      title: 'Services',
      content: 'We offer software development, system integration, and intelligent building design.'
    },
    solutions: {
      title: 'Solutions',
      learnMore: 'More',
      accessControl: {
        title: 'Smart Access Control',
        content: 'SHM access control includes standalone devices, cloud platforms and mobile apps. Our products provide security, manageability and flexibility for various scenarios.'
      },
      smartDisplay: {
        title: 'Smart Display Cabinet',
        content: 'SHM display cabinets create safer, smarter protection for retail digital transformation. They solve issues with traditional locks and information silos, improving efficiency and management.'
      },
      smartLocker: {
        title: 'Smart Locker',
        content: 'SHM storage system offers multiple access methods for quick item retrieval. It combines security with convenience, improves space usage, and supports flexible permission settings.'
      },
      glassDoor: {
        title: 'Glass Door Smart Lock',
        content: 'Industry-first innovation & proprietary design; supports multi-format cards, mobile NFC unlocking, wireless connectivity & standalone operation; wire-free, integrated handle installation; ideal for diverse scenarios.'
      },
      smartBuilding: {
        title: 'Smart Building\nLighting Control',
        content: 'One-click scene control for lighting, AC, curtains, projection and ventilation. Example: projection mode automatically closes curtains, dims lights, lowers screen and starts projector.'
      },
      rfidTake: {
        title: 'RFID Smart Inventory System',
        content: 'Leveraging RFID technology with tags, readers, antennas, and a backend management platform, this system enables rapid jewelry inventory counting and intelligent anti-loss monitoring. It significantly enhances store management efficiency and security while optimizing the overall customer experience.'
      }
    },
    businessCoverage: {
      title: 'Coverage',
      content: 'We have complete R&D, design, sales and service systems with headquarters in Shanghai and offices across China.'
    },
    markets: {
      banking: 'Banking',
      school: 'Education',
      smartBuilding: 'Smart Buildings',
      hospital: 'Healthcare',
      retail: 'Retail',
      jewelry: 'Jewelry'
    },
    nav: {
      home: 'Home',
      qualification: 'Qualifications',
      products: 'Products',
      aftersales: 'Support',
      contact: 'Contact'
    }
  },
  about: {
    company: {
      title: 'Company Profile',
      content: 'Shanghai Shanmai Technology is a high-tech enterprise specializing in technical services and development.'
    },
    vision: {
      title: 'Vision',
      content: 'To become a leading technology provider and create greater value for customers.'
    },
    mission: {
      title: 'Mission',
      content: 'Drive industry development through technological innovation and enhanced user experience.'
    }
  },
  contact: {
    title: 'Contact Us',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    message: 'Message',
    name: 'Name',
    content: 'Content',
    submit: 'Submit',
    banner: {
      title: 'Contact',
      description: 'Get the latest information and feel the company charm'
    },
    companyPhone: 'Company Phone',
    contactPerson: 'Contact (Manager Li)',
    salesDirector: 'Sales Director (Manager cui)',
    companyEmail: 'Email',
    headquarters: 'Headquarters: Room 203, Building B, Baodi Plaza, 588 Dalian Road, Yangpu District, Shanghai'
  },
  footer: {
    companyOverview: 'Company',
    companyProducts: 'Products',
    serviceSupport: 'Support',
    contactUs: 'Contact Us',
    smartDisplay: 'Smart Display',
    accessControl: 'Smart Access Control',
    softwarePlatform: 'Software',
    solutions: {
      accessControl: 'Smart Access Control',
      smartDisplay: 'Smart Display',
      smartLocker: 'Smart Locker',
      glassDoor: 'Glass Door Smart Lock',
      smartBuilding: 'Smart Building'
    },
    serviceHotline: 'After-sales service hotline',
    serviceEmail: 'Email',
    address: 'HQ: Room 203, Building B, Baodi Plaza, 588 Dalian Road, Yangpu District, Shanghai',
    copyright: 'Copyright ©Shanghai Shanmai Technology Development Co, Ltd',
    icp: 'ICP No. 19035700'
  },
  products: {
    specifications: 'Specifications',
    productDetails: 'Product Specifications',
    displayCase: {
      categories: {
        electronicLock: 'Electronic Lock',
        cardReader: 'Card Reader',
        controller: 'Controller',
        powerSupply: 'Power Supply'
      },
      items: {
        miniatureElectronicLock: {
          name: 'Miniature Electronic Lock',
          description: 'This product is our original invention, design and production, with stable and reliable quality. It complies with public security and fire protection requirements, uses one-time casting process, is wear-resistant and corrosion-resistant, and perfectly combines mechanical structure with electronic control system.'
        },
        smartEjectionLock: {
          name: 'Smart Ejection Lock',
          description: 'Stable and reliable product quality; complies with public security and fire protection requirements'
        },
        concealedMagneticLock: {
          name: 'Concealed Magnetic Lock',
          description: 'Aluminum alloy shell enhances product quality feel, with built-in reverse breakthrough protection'
        },
        cylindricalCardReader: {
          name: 'Cylindrical Card Reader (Surface Mount)',
          description: 'Cylindrical design is simple and durable, color can be customized according to user needs, embedded with red and green dual-color LED backlight indicators to display locker status, can be embedded in metal surface'
        },
        implicitCardReader: {
          name: 'Card Reader (Hidden Installation)',
          description: 'Clean panel design, smart chip, outdoor waterproof design. Good anti-metal interference, can be hidden installation'
        },
        allInOneCardReader: {
          name: 'All-in-One Card Reader',
          description: 'Integrates card reader and controller into one unit, enabling standalone operation for single door control. Compact and simple installation, supports embedded and surface mounting, features card swipe buzzer and LED light feedback, and supports up to 1024 users.'
        },
        singleDoorController: {
          name: 'Single Door Controller',
          description: 'Standard Wiegand reader interface, electric lock interface, door contact interface with door closing delay time setting'
        },
        threeDoorController: {
          name: 'Three Door Controller',
          description: 'Standard Wiegand reader interface, electric lock interface, door contact interface with door closing delay time setting'
        },
        sixDoorController: {
          name: 'Six Door Controller',
          description: 'Standard Wiegand reader interface, electric lock interface, door contact interface with door closing delay time setting'
        },
        tenDoorController: {
          name: 'Ten Door Controller',
          description: '10-channel electric lock, supports both power-on and power-off locks, supports door contact input, 2A@12V electric lock, 2-second action time'
        },
        integratedPowerSupply: {
          name: 'Dedicated Integrated Power Supply',
          description: '9-channel 12V dedicated integrated power supply, convenient installation in storage compartments and desktops; front panel configured with LED power indicator; built-in CQC-certified industrial-grade module power supply with short circuit protection, overcurrent protection, and overload protection'
        },
        switchingPowerSupply: {
          name: 'Switching Power Supply',
          description: 'Device body made of metal material, power supply bottom cover uses aluminum alloy material, with reserved holes for bottom and front installation for different installation scenarios; power supply top cover features hexagonal honeycomb holes throughout the cover for better device heat dissipation'
        }
      }
    },
    productParam: {
      products: {
        accessControlCardReader: {
          name: 'Smart Access Control Card Reader (Card/Keypad/Fingerprint)',
          features: [
            'Supports 13.56MHz high frequency',
            'Supports configuration card to change reader parameters',
            'Supports single fingerprint, card + fingerprint mode',
            'Capacitive touch keypad',
            'Supports power reverse connection protection',
            'Tamper protection (photoresistor)',
            'Input and output signal ESD protection',
            'Supports customized panel design'
          ]
        },
        accessControlCardReaderFingerprint: {
          name: 'Smart Access Control Card Reader (Card/Fingerprint)',
          features: [
            'Supports 13.56MHz high frequency',
            'Supports configuration card to change reader parameters',
            'Supports single fingerprint, card + fingerprint mode',
            'Supports power reverse connection protection',
            'Tamper protection (photoresistor)',
            'Input and output signal ESD protection',
            'Supports customized panel design'
          ]
        },
        accessControlCardReaderKeypad: {
          name: 'Smart Access Control Card Reader (Card/Keypad)',
          features: [
            'Supports 13.56MHz high frequency',
            'Supports configuration card to change reader parameters',
            'Capacitive touch keypad',
            'Supports power reverse connection protection',
            'Tamper protection (photoresistor)',
            'Input and output signal ESD protection',
            'Supports customized panel design'
          ]
        },
        accessControlCardReaderSwipe: {
          name: 'Smart Access Control Card Reader (Card Only)',
          features: [
            'Supports 13.56MHz high frequency',
            'Supports configuration card to change reader parameters',
            'Supports power reverse connection protection',
            'Tamper protection (photoresistor)',
            'Input and output signal ESD protection',
            'Supports customized panel design'
          ]
        },
        wirelessElectronicLock: {
          name: 'Wireless Electronic Lock',
          features: [
            'Smart, secure, innovative and easy to install',
            'Electronic door lock requires no wiring, providing a feature-rich wireless networked electronic door lock solution',
            'Reversible handle electronic lock',
            'Clutch-type electronic lock, handle can rotate freely after unlocking',
            'Compatible with European standard and Swiss standard lock cylinders',
            'Simple installation for any type of door',
            'Steel structure for lock body and electronic handle',
            'Mechanical cylinder opening available for mechanical key unlocking or locking, can be tracked through audit trail',
            'Door lock can always be opened from inside (select appropriate core lock body, simple handle press operation enables emergency escape)'
          ]
        },
        pullLock: {
          name: 'Pull Handle Lock',
          features: [
            'Mobile phone remote unlocking',
            'Unique security gateway, ensuring information security',
            'Power reverse connection protection',
            'Integrated design, easy operation',
            'Supports NFC, card swipe mode',
            'Tamper protection (photoresistor)',
            'Input and output signal ESD protection',
            'Supports 13.56MHz high frequency'
          ]
        },
        faceRecognitionMachine: {
          name: 'Facial Recognition Terminal',
          features: [
            'Anti-theft attack',
            'Liveness detection',
            'Supports transmission',
            'Information encryption'
          ]
        },
        accessController: {
          name: 'Smart Access Control Panel',
          features: [
            'RS485 and Wiegand dual communication interfaces can connect to readers including facial recognition, card readers, fingerprint, and dual verification with face plus card',
            'Connects to S-MAX.A intelligent access control management platform via tcp/ip wired network for management'
          ]
        },
        miniatureElectronicLock: {
          name: 'Miniature Electronic Lock',
          features: [
            'Original invention, design and production, stable and reliable product quality',
            'One-time casting process, wear-resistant and corrosion-resistant',
            'Perfect combination of mechanical structure and electronic control system',
            'New anti-pry function design',
            'Lock body color can be customized'
          ]
        },
        smartEjectionLock: {
          name: 'Smart Ejection Lock',
          features: [
            'Power-on ejection / power-off manual door closing and locking',
            'Locked closed / unlocked open'
          ]
        },
        concealedMagneticLock: {
          name: 'Concealed Magnetic Lock',
          features: [
            'Aluminum alloy shell',
            'Built-in reverse breakthrough protection',
            'Application range: drawers, sliding doors, cabinet doors, etc.'
          ]
        },
        cylindricalCardReader: {
          name: 'Cylindrical Card Reader (Surface Mount)',
          features: [
            'Supports HID Prox compatible cards, ISO14443A, ISO15693 and other card technologies (different card technologies available)',
            'Embedded red and green dual-color LED backlight indicators to display locker status',
            'Two designs for rear threaded interface'
          ]
        },
        implicitCardReader: {
          name: 'Card Reader (Hidden Installation)',
          features: [
            'Smart chip',
            'Outdoor waterproof design',
            'Good anti-metal interference',
            'Hidden installation available'
          ]
        },
        allInOneCardReader: {
          name: 'All-in-One Card Reader',
          features: [
            'Compact and simple',
            'Embedded installation',
            'Surface mounting',
            'Supports 1024 users'
          ]
        },
        tenDoorController: {
          name: 'Ten-Door Controller for Lockers',
          features: [
            'Supports power-on and power-off locks',
            'Supports door contact input',
            'Supports red and green indicator light feedback'
          ]
        },
        singleDoorController: {
          name: 'Single Door Controller',
          features: [
            '10,000 cardholders, 50,000-100,000 offline events',
            'Supports door closing delay time setting',
            'Surface mounting',
            'TCP/IP network communication',
            'Wireless WIFI connection',
            'Standard Wiegand reader interface, electric lock interface, door contact interface'
          ]
        },
        threeDoorController: {
          name: 'Three Door Controller',
          features: [
            '10,000 cardholders, 50,000-100,000 offline events',
            'Supports door closing delay time setting',
            'Surface mounting',
            'TCP/IP network communication',
            'Wireless WIFI connection',
            'Standard Wiegand reader interface, electric lock interface, door contact interface'
          ]
        },
        sixDoorController: {
          name: 'Six Door Controller',
          features: [
            '10,000 cardholders, 50,000-100,000 offline events',
            'Supports door closing delay time setting',
            'Surface mounting',
            'TCP/IP network communication',
            'Wireless WIFI connection',
            'Standard Wiegand reader interface, electric lock interface, door contact interface'
          ]
        },
        integratedPowerSupply: {
          name: 'Dedicated Integrated Power Supply',
          features: [
            'Convenient installation in storage compartments and desktops',
            'Front panel configured with LED power indicator',
            'Built-in CQC-certified industrial-grade module power supply with short circuit protection, overcurrent protection, and overload protection',
            'Input with short circuit fuse protection',
            'Each output channel has independent indicator light, with short circuit protection, overcurrent protection, overload protection; each channel terminal can be plugged and unplugged for easy installation and maintenance',
            'Standard Wiegand reader interface, electric lock interface, door contact interface',
            'Reliable lightning protection grounding'
          ]
        },
        switchingPowerSupply: {
          name: 'Switching Power Supply',
          features: [
            'Device body made of metal material, power supply bottom cover uses aluminum alloy material',
            'Power supply top cover features hexagonal honeycomb holes throughout the cover for better device heat dissipation',
            'Reserved holes for bottom and front installation for different installation scenarios'
          ]
        },
        contactFreeSwitch: {
          name: 'Contactless Door Open Button',
          features: [
            'Contactless',
            'Uses contactless capacitive sensing technology'
          ]
        }
      },
      parameters: {
        deviceParams: 'Device Parameters',
        usageParams: 'Usage Parameters',
        workingVoltage: 'Working Voltage',
        cardFrequency: 'Card Frequency',
        readerConfig: 'Reader Configuration',
        standardOutput: 'Standard Output',
        readerOutputFormat: 'Reader Output Format',
        inputControl: 'Input Control',
        wiegandWidth: 'Wiegand Width',
        keypadFormat: 'Keypad Format',
        readDistance: 'Reading Distance',
        waterproofLevel: 'Waterproof Level',
        productSize: 'Product Size',
        shellMaterial: 'Shell Material',
        productColor: 'Product Color',
        workingTemperature: 'Working Temperature',
        workingHumidity: 'Working Humidity',
        doorThickness: 'Applicable Door Thickness',
        size: 'Size',
        handleRotationAngle: 'Handle Rotation Angle',
        handleToCylinderDistance: 'Handle to Cylinder Distance',
        operatingSystem: 'Operating System',
        faceRecognition: 'Facial Recognition',
        mainChipSpecs: 'Main Chip Specifications',
        memory: 'Memory',
        wifiBluetoothModule: 'WiFi Bluetooth Module',
        deviceSize: 'Device Size (L×W×H)',
        cameraModule: 'Camera Module (Dual)',
        fillLight: 'Fill Light',
        display: 'Display',
        screenRatio: 'Screen Ratio -- Resolution',
        devicePower: 'Device Power',
        deviceWattage: 'Device Wattage',
        processor: 'Processor',
        storageCapacity: 'Storage Capacity',
        workingCurrent: 'Working Current',
        alarmOutput: 'Alarm Output',
        lockRelay: 'Lock Relay',
        bearableForce: 'Bearable Force',
        unlockMethod: 'Unlock Method',
        lockBodySize: 'Lock Body Size',
        lockPlateSize: 'Lock Plate Size',
        electricalParams: 'Electrical Parameters',
        workingMode: 'Working Mode',
        feedbackSignal: 'Feedback Signal',
        doorOpeningForce: 'Door Opening Force',
        suctionPlateSize: 'Suction Plate Size',
        tensileStrength: 'Tensile Strength',
        installationMethod: 'Installation Method',
        maxOutputPower: 'Maximum Output Power',
        outputVoltage: 'Output Voltage',
        maxOutputCurrent: 'Maximum Output Current',
        singleChannelOutputCurrent: 'Single Channel Output Current',
        inputVoltage: 'Input Voltage',
        maxInputCurrent: 'Maximum Input Current',
        standbyPowerConsumption: 'Standby Power Consumption',
        outputProtection: 'Output Protection',
        totalOutputCurrent: 'Total Output Current',
        appearanceMaterial: 'Appearance Material',
        alarmSound: 'Alarm Sound',
        communicationProtocol: 'Communication Protocol',
        indicatorLight: 'Indicator Light',
        structure: 'Structure',
        protectionLevel: 'Protection Level',
        readingDistance: 'Reading Distance',
        cardReaderInterface: 'Card Reader Interface',
        values: {
          shaTouMenHouDu: "32mm to 120mm",
          shaTouSuoXinDaoBaShou: "47mm to 110mm (Lock Cylinder to Handle)",
          duKaQiPeiZhi: "Within 30 minutes after restart",
          weiGenShuChu: "Wiegand (RS232 and RS485 optional)",
          duKaQiShuChuGeShi: "125KHz: HID-compatible card format, EM 26bits (default); 13.56MHz: UID 32bits, 34bits, 56bits (reverse/forward), programmed card number",
          shuRuKongZhi: "Tri-color LED, buzzer",
          weiGenKuanDu: "Different options available per the requirements of different controllers",
          waiKeCaiZhi: "Aluminum",
          waiKeCaiZhiJinShu: "Metal",
          chanPinYanSe: "Silver, black",
          heiBai: "Black, white",
          tanHuiSe: "Carbon gray",
          gongZuoShiDu: "10%~90% RH (non-condensing)",
          renLianShiBie: "Max. 10,000 users; 1:1 mode, 1:N mode, hybrid mode",
          sheBeiChiCun: "78×141×60 (mm) / 122×14.05×215 (mm)",
          sheXiangTouMoZu: "Dual-camera 2MP, visible light + near-infrared",
          buGuangDeng: "White light / infrared light 850nm",
          gongZuoShiDuBuJingJieShuiDi: "0%-90% RH (no water droplet condensation)",
          gongZuoDianYa12V: "Built-in chassis and power supply (AC220V backup for several days), working voltage DC 12V, power consumption ≤ 4W (no load)",
          chuLiQi32: "32-bit processor",
          cunChuRongLiang: "Storage capacity: 50,000 cards and 100,000 offline records",
          baoJingShuChu: "Dry contact output, 30VDC max. 2A",
          kaiSuoFangShi: "Supports power-on unlocking / power-off unlocking",
          gongZuoFangShi: "Power-on ejection / power-off manual door closing and locking",
          fanKuiXinHao: "Closed when locked / Open when unlocked",
          waiKeCaiZhiABSandPc: "ABS+PC frosted shell",
          dingZhiYanSe: "Customizable",
          biaoMianHuoQianRu: "Surface mounting, flush mounting",
          TCPTongXun: "TCP network communication",
          dianSuoJieKou: "10-channel electric lock interfaces, supporting powered/unpowered locks and door magnetic input; 2A@12V electric lock, action time 2s",
          duKaQiJieKou: "10-channel card reader interfaces, supporting red/green indicator feedback; 5VDC power supply, Wiegand card reader interface",
          danLuShuChu: "Channels 1~5: max. 5A current; Channels 6~9: max. 3A current;",
          chiCun1: "240mm×164mm×44mm (Width × Depth × Height)",
          shuChuBaoHu: "Output short-circuit, overcurrent, overvoltage, overtemperature protection",
          shiDuWuLengJing: "20~90% RH, no condensation",
          fengMingQi: "Buzzer",
          dianYuanZhiShiDeng: "Power indicator light and status indicator light",
          suLiaoMianBan: "Plastic panel",
          qianRuShi86DianHe: "Suitable for flush-mounted 86-type electrical boxes"
        }
      }
    }
  },
  entranceGuard: {
    bannerTitle: 'Smart Access Control',
    bannerDescription: 'The smart access control management system is built on a public intelligent management platform. The system has been tested by the Public Security Third Research Institute and complies with national standards and Shanghai public security technical prevention standards. It can effectively manage the opening and closing of doors, ensuring authorized personnel can freely enter and exit while restricting unauthorized personnel.',
    categoryName: {
      cardReader: 'Card Reader',
      wirelessLock: 'Wireless Lock',
      faceRecognition: 'Face Recognition Terminal',
      controller: 'Smart Access Controller',
      openButton: 'Door Open Button'
    },
    cardReader: {
      cardKeypadFingerprint: 'Access Control Reader (Card/Keypad/Fingerprint)',
      cardFingerprint: 'Access Control Reader (Card/Fingerprint)',
      cardKeypad: 'Access Control Reader (Card/Keypad)',
      cardOnly: 'Access Control Reader (Card Only)',
      aluminumDescription: 'Aluminum alloy shell enhances product quality and anti-interference capability, suitable for modern and industrial buildings',
      capacitiveDescription: 'Aluminum alloy shell enhances product quality and anti-interference capability, suitable for modern and industrial buildings; Capacitive fingerprint module improves recognition speed and accuracy'
    },
    wirelessLock: {
      wirelessLock: 'Wireless Electronic Lock',
      pullLock: 'Pull Lock',
      wirelessDescription: 'Smart, secure, innovative and easy to install, electronic door locks require no wiring, providing feature-rich wireless electronic door lock solutions',
      pullLockDescription: 'Smart glass door pull lock can be concealed inside the glass door handle without additional lock installation. It has multiple identification methods such as card reading and NFC, connected to a private security gateway via Bluetooth wireless transmission'
    },
    faceRecognition: {
      faceRecognition: 'Face Recognition Terminal',
      faceRecognitionDescription: 'Face recognition access control products are available in 8-inch and 5.5-inch models, with the 5.5-inch product optionally configured with an IC card reader • Suitable for door thickness: 32mm to 120mm.'
    },
    controller: {
      accessController: 'Smart Access Controller',
      accessControllerDescription: 'The access controller can simultaneously control multiple door locks, with RS485 and Wiegand dual communication interfaces that can connect to reading devices including face recognition, card readers, fingerprints, and dual verification of face plus card.'
    },
    openButton: {
      contactFree: 'Contactless Door Open Button',
      contactFreeDescription: 'SHM-RE0100 (Intelligence Request to Exit Button) is a contactless exit switch that uses contactless capacitive sensing technology.'
    }
  },
  displayCase: {
    bannerTitle: 'Smart Display Cabinet | Smart Storage Locker',
    bannerDescription: 'Smart display cabinets and storage lockers are intelligent units integrated with digital technology and custom multimedia content. The cloud-based management platform enables asset & status monitoring via smart controllers, with easy remote access to in-store cabinet data—cutting on-site inefficiencies, reducing equipment loss risks, and boosting management efficiency.',
    categoryName: {
      electronicLock: 'Electronic Lock',
      cardReader: 'Card Reader',
      controller: 'Controller',
      powerSupply: 'Power Supply'
    },
    electronicLock: {
      miniatureLock: 'Miniature Electronic Lock',
      smartEjectionLock: 'Smart Ejection Lock',
      concealedMagneticLock: 'Concealed Magnetic Lock',
      miniatureLockDescription: 'uses casting process for one-time molding, wear-resistant and corrosion-resistant; perfect combination of mechanical structure and electronic control system.',
      smartEjectionLockDescription: 'Stable and reliable product quality; complies with public security and fire protection requirements',
      concealedMagneticLockDescription: 'Aluminum alloy shell enhances product quality, with built-in reverse breakthrough protection'
    },
    cardReader: {
      cylindricalReader: 'Cylindrical Card Reader (Surface Mount)',
      implicitReader: 'Card Reader (Implicit Installation)',
      allInOneReader: 'All-in-One Card Reader',
      cylindricalReaderDescription: 'Cylindrical design is simple and durable, color can be customized according to user needs, embedded with red and green dual-color LED backlight indicator to display cabinet status, can be embedded in metal surface by drilling.',
      implicitReaderDescription: 'Simple panel design, smart chip, outdoor waterproof design. Good anti-metal interference, can be installed hidden',
      allInOneReaderDescription: 'Integrates card reader and controller into one unit, achieving standalone operation for single door control, compact and simple installation, supports embedded installation and surface installation, features card swipe buzzer and LED light feedback prompt, supports up to 1024 users.'
    },
    controller: {
      singleDoorController: 'Single Door Controller',
      threeDoorController: 'Three Door Controller',
      sixDoorController: 'Six Door Controller',
      tenDoorController: 'Ten Door Controller',
      standardControllerDescription: 'Standard Wiegand card reader interface, electric lock interface, door magnetic interface supports door closing delay time setting',
      tenDoorControllerDescription: '10 electric lock channels, supports normally energized and normally de-energized locks, supports door magnetic input, 2A@12V electric lock, action time 2 seconds'
    },
    powerSupply: {
      integratedPowerSupply: 'Dedicated Integrated Power Supply',
      switchingPowerSupply: 'Switching Power Supply',
      integratedPowerSupplyDescription: '9-channel 12V dedicated integrated power supply; front panel configured with LED power indicator; built-in CQC-certified industrial-grade module power supply with short circuit protection, overcurrent protection, and overload protection.',
      switchingPowerSupplyDescription: 'The device body is made of metal, the power supply bottom cover is made of aluminum alloy, and has reserved holes for installation from the bottom and front, for easy installation in different scenarios.'
    }
  },
  services: {
    accessControlSystem: {
      title: 'Smart Management',
      description: 'SHM access control system includes standalone devices, cloud platforms and mobile apps. Our products excel in security, manageability and flexibility, providing comprehensive security and management solutions.',
      productHardware: 'Product Hardware',
      productOverview: 'Product Overview',
      productHardwareDesc: 'SHM access control products include intelligent personnel identification, controllers, card readers and more, offering high efficiency, accuracy, security and convenience.',
      involvedProducts: 'Products Involved',
      devices: {
        cardReader: {
          title: 'Access Control Card Reader',
          description: 'SHM card readers feature simple design, fast scanning and high recognition rates, supporting both card and fingerprint authentication.'
        },
        faceRecognition: {
          title: 'Facial Recognition Terminal',
          description: 'SHM facial recognition terminals use deep learning algorithms with independent storage, ensuring fast and accurate recognition.'
        },
        controller: {
          title: 'Access Controller',
          description: 'SHM multifunctional controllers support RS485 and Wiegand interfaces, connecting to S-MAX.A platform via TCP/IP for complex access control scenarios.'
        },
        contactlessButton: {
          title: 'Contactless Exit Button',
          description: 'SHM-RE0100 uses capacitive sensing technology for contactless operation.'
        }
      }
    },
    smartDisplayCase: {
      title: 'Operational Data Visualization',
      description: 'SHM smart display cabinets create a safer, smarter protection system for high-end retail digital transformation. They address traditional mechanical lock limitations and information silos, streamlining operations and improving efficiency.',
      productHardware: 'Product Hardware',
      productHardwareDesc: 'SHM display cabinets feature miniature electric locks, card readers and controllers, offering both networked and standalone solutions with flexible control options.',
      involvedProducts: 'Products Involved',
      devices: {
        miniatureLock: {
          title: 'Miniature Electronic Lock (Bolt Lock)',
          description: 'Self-developed with stable quality, anti-pry design, and perfect integration of mechanical and electronic systems.'
        },
        cardReader: {
          title: 'Card Reader',
          description: 'Clean design with smart chip and excellent anti-metal interference, suitable for hidden installation.'
        },
        cardReaderIntegrated: {
          title: 'All-in-One Card Reader',
          description: 'Combines reader and controller with RS485/Wiegand interfaces, connecting to S-MAX.A platform for comprehensive access control.'
        },
        controller: {
          title: 'Controller',
          description: 'Supports 10,000 cardholders, 50,000-100,000 offline events, TCP/IP and WiFi connectivity, with standard interfaces for readers and locks.'
        }
      }
    },
    smartLockers: {
      title: 'Smart Management | Safe and Stable',
      description: 'SHM smart storage system offers multiple access methods for quick item storage and retrieval. It combines security with convenience, improving space utilization and enabling flexible permission management.',
      productHardware: 'Product Hardware',
      productHardwareDesc: 'SHM storage series includes cabinet locks, controllers, card readers and related equipment, providing comprehensive, secure and reliable solutions.',
      involvedProducts: 'Products Involved',
      devices: {
        miniatureLock: {
          title: 'Miniature Electronic Lock (Bolt/Spring Lock)',
          description: 'Self-developed with stable quality, anti-pry design, and perfect integration of mechanical and electronic systems.'
        },
        cardReader: {
          title: 'Card Reader',
          description: 'Clean design with excellent anti-metal interference.'
        },
        specialController: {
          title: 'Storage Cabinet Controller',
          description: 'Supports 10,000 cardholders, 50,000-100,000 offline events, TCP/IP and WiFi connectivity, with standard interfaces for readers and locks.'
        },
        integratedPowerSupply: {
          title: 'Integrated Power Supply (9-Port)',
          description: 'Industrial-grade power supply with comprehensive protection features and pluggable terminals for easy maintenance.'
        }
      }
    },
    glassDoorHandleSmartLock: {
      title: 'Smart Management | Safe and Stable',
      description: 'Smart glass door handle lock integrates seamlessly into the handle without additional hardware.',
      productHardware: 'Product Hardware',
      productOverview: 'Product Overview',
      productHardwareDesc: 'Features card reading and NFC capabilities, connected via Bluetooth to a private security gateway.',
      featureOverview: "Feature Overview",
      featureOverviewDesc: "Real-time monitoring and management of door lock status via mobile app \r\n" +
          "User Management: Administrators can edit user information to facilitate the management of members and visitors \r\n " +
          "Enables headquarters to centrally monitor and manage attendance data of nationwide stores in real-time \r\n " +
          "Supports multiple unlocking methods such as NFC, card access, and remote unlocking via mobile app \r\n " +
          "Supports battery level monitoring",
      involvedProducts: 'Products Involved',
      devices: {
        pullLock: {
          title: 'Pull Handle Lock',
          description: 'Integrates card reading and NFC capabilities, connected via Bluetooth to a private security gateway.'
        }
      }
    },
    smartBuildings: {
      title: 'Smart Management | Safe and Stable',
      description: 'Creating comfortable, elegant lighting environments for customers at all times.',
      architecture: {
        lobbyReception: {
          title: 'Lobby/Reception/Bar',
          description: 'Essential guest entry point with intelligent lighting that adapts to morning, noon and evening scenes, combining natural and artificial light for a layered experience.'
        },
        banquetRestaurant: {
          title: 'Banquet Hall/Restaurant',
          description: 'Handles multiple scenarios including preparation, cleaning, welcome, dining and departure modes, with intelligent control of downlights, wall lamps and light strips.'
        },
        conferenceRoom: {
          title: 'Conference Room',
          description: 'One-click scene control for lighting, AC, curtains, projection and ventilation. Projection mode automatically adjusts lighting and equipment for optimal presentation.'
        }
      }
    },
    rfidTake: {
      title: 'RFID | Item Inventory',
      description: 'By deploying hardware devices such as RFID tags, readers, intelligent fences, and electronic access control, along with a background management system, functions including rapid inventory, real-time monitoring, anti-theft alarm, and data management are realized, improving store operation efficiency and security.',
      productHardware0: "Overall System Architecture of Intelligent Display Cabinets",
      productHardware: "Goods Anti-Loss",
      productHardwareDesc: "Each piece of jewelry is equipped with a unique RFID tag, and RFID readers are installed at key locations to monitor tag information in real time. An alarm is triggered when jewelry leaves the predetermined area or has abnormal movement, thereby achieving anti-loss application for jewelry.",
      productHardware1: "Intelligent Store Management",
      productHardwareDesc1: "RFID technology is used to quickly read goods information to achieve fast and intelligent inventory, thus saving labor costs, improving inventory efficiency, and achieving the goal of cost reduction and efficiency improvement;\n" +
          "By installing electronic access control on the display cabinets of jewelry stores, effective control of jewelry goods can be achieved. Only authorized personnel can open the display cabinets to prevent unauthorized\n" +
          "operations and access, thereby enhancing the safety factor of the goods.",
      architecture: {
        rfidRead: {
          title: 'Fixed RFID Reader',
          description: 'Fixed RFID readers are devices deployed at key areas such as store entrances/exits and counters. They can read tag information in real time and link with the system to realize illegal movement alarm and data management.'
        },
        labelPrint: {
          title: 'Label Printer',
          description: 'RFID label printers can read and write label chip data and perform visual printing, adapt to various inventory management needs, facilitate identity identification and full-process tracking, and improve management efficiency.'
        },
        handheldTerminal: {
          title: 'Intelligent Handheld Terminal',
          description: 'The intelligent handheld terminal is an efficient management tool for jewelry stores. It supports Bluetooth connection, can read RFID tag information in real time, and conveniently complete operations such as inventory and data synchronization, improving on-site management efficiency.'
        },
        rfidAntenna: {
          title: 'RFID Antenna',
          description: 'RFID antennas are used in conjunction with readers. By transmitting radio frequency signals and receiving tag responses, they achieve accurate collection of tag information, providing basic support for real-time store monitoring and data management.'
        }
      }
    }
  },
  entranceGuardSoftware: {
    bannerTitle: 'Smart Access Control Platform',
    title: 'Smart Access Control Platform',
    description: 'Shanmai Access Control Platform integrates advanced technology with user-friendly design for comprehensive access management.',
    mainAdvantages: 'Key Advantages',
    advantages: {
      accessControl: 'Channel access permission management',
      realTimeMonitoring: 'Real-time monitoring',
      alarmFunction: 'Anomaly alarm',
      networkMonitoring: 'Network settings and monitoring',
      areaRollCall: 'Area roll call',
      fireAlarm: 'Fire alarm monitoring and linkage',
      logicalOpening: 'Logical door opening',
      antiTailgating: 'Anti-tailgating interlock',
      antiPassBack: 'Anti-passback'
    }
  },
  exhibitionSoftware: {
    bannerTitle: 'Smart Display Cabinet Platform',
    title: 'Smart Display Cabinet Platform',
    description: 'Shanmai Display Cabinet Platform integrates advanced technology with user-friendly design for comprehensive display management.',
    mainAdvantages: 'Key Advantages',
    advantages: {
      realTimeManagement: '"Real-time" comprehensive management',
      multiSystemSupport: 'Multiple system support',
      communicationType: 'Server and wireless controller communication',
      windowsSupport: 'Windows platform support'
    }
  },
  aftTheSoftware: {
    bannerTitle: 'After-sales Service',
    title: 'After-sales Service',
    subtitle: 'Full-service support',
    serviceItems: {
      wechatRepair: 'WeChat Repair',
      mobileWorkOrder: 'Mobile Work Orders',
      wechatRepairDesc: 'One-click repair, intelligent dispatching, engineer tracking.',
      customerManagement: 'Customer Management',
      voiceCall: 'Voice Call',
      customerManagementDesc: 'Customer binding, one-click query, direct engineer call.',
      engineerManagement: 'Engineer Management',
      areaRefinement: 'Area Assignment',
      engineerManagementDesc: 'Detailed area division, clear responsibilities, better store insights.',
      workOrderManagement: 'Work Order Management',
      historyView: 'History',
      workOrderManagementDesc: 'Intelligent work order management with clear results.',
      pcReport: 'PC Reports',
      pcReportDesc: 'PC report center with one-click export.'
    },
    processTitle: 'Service Process',
    processSubtitle: 'End-to-end support',
    processSteps: {
      submitWorkOrder: 'Submit Order',
      submitWorkOrderDesc: 'Multi-channel repair submission.',
      acceptWorkOrder: 'Accept Order',
      acceptWorkOrderDesc: 'Customer service accepts orders.',
      assignWorkOrder: 'Assign Engineer',
      assignWorkOrderDesc: 'One-click engineer assignment with reminders.',
      acceptOrder: 'Engineer Accepts',
      acceptOrderDesc: 'Engineer one-click order acceptance.',
      returnOrder: 'Return/Redispatch',
      returnOrderDesc: 'Handle exceptions.',
      closeOrder: 'Close Order',
      closeOrderDesc: 'Submit completion and satisfaction evaluation.',
      satisfactionCall: 'Satisfaction Follow-up',
      satisfactionCallDesc: 'Automatic evaluation push.',
      finalizePayment: 'Finalize',
      finalizePaymentDesc: 'Close order and report.'
    }
  }
}
